import { draftsTabUIInitialState } from "./uiLandingPageDraftsTabState";
import { makeDraftsTabUIActions } from "./uiLandingPageDraftsTabActions";

export const createDraftsTabUISlice = (set, get) => ({
  draftsTabUI: draftsTabUIInitialState,
  draftsTabUIActions: Object.freeze(makeDraftsTabUIActions(set, get)),
});
